import dayjs from 'dayjs'
import { CuratedTemplateAvailability } from '../../../domain/curatedTemplates/curatedTemplate'

export const LAST_UPDATED_FORMAT = 'MMM D, YYYY h:mm A'

export const availabilityLabels: Record<CuratedTemplateAvailability, string> = {
  draft: 'Draft',
  published: 'Published'
}

export const curatedAvailabilityOptions: { label: string, value: CuratedTemplateAvailability }[] = [
  { label: availabilityLabels.draft, value: 'draft' },
  { label: availabilityLabels.published, value: 'published' }
]

export type AvailabilityDisplay = {
  label: string
  color: string
}

export const availabilityDisplay = (availability: CuratedTemplateAvailability): AvailabilityDisplay => ({
  label: availabilityLabels[availability],
  color: availability === 'published' ? 'green' : 'default'
})

export const formatLastUpdated = (lastUpdatedAt: string | null | undefined): string => {
  const parsed = dayjs(lastUpdatedAt ?? '')
  if (!parsed.isValid()) {
    return ''
  }
  return parsed.format(LAST_UPDATED_FORMAT)
}

export const formatLastUpdatedLabel = (lastUpdatedAt: string | null | undefined): string => {
  const formatted = formatLastUpdated(lastUpdatedAt)
  if (formatted === '') {
    return ''
  }
  return `Last updated ${formatted}`
}
